export default __webpack_public_path__ + "static/media/loading.b2ad0d58.svg";